import React, {Component} from 'react'

import MS from './../services/Moment'

import { DateRangePicker } from 'element-react';
import 'element-theme-default';

import { i18n } from 'element-react'
import locale from 'element-react/src/locale/lang/ko'
import { withTranslation } from 'react-i18next';

i18n.use(locale);

class DateRange extends Component {

    constructor(props) {
        super(props);
        this.state = {value1: null, value2: null}
    }

    handleChange(ranges) {
        this.setState({value2: ranges})
        this.props.handleDateChange([MS.format(ranges[0], 'YYYY-MM-DD'), MS.format(ranges[1], 'YYYY-MM-DD')]);
    }

    render() {
        const {
            // value1, 
            value2
        } = this.state
        const { t } = this.props;
        return (
            <>
                <DateRangePicker
                    value={value2}
                    placeholder={t("key387")}
                    align="right"
                    ref={e=>this.daterangepicker2 = e}
                    onChange={date => this.handleChange(date)}
                    /*
                    onChange={date=>{
                        console.log('DateRangePicker2 changed: ', date)
                        this.setState({value2: date});
                    }}
                    */
                    shortcuts={[{
                        text: '일주일',
                        onClick: ()=> {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            this.setState({value2: [start, end]})
                            this.daterangepicker2.togglePickerVisible()
                            this.handleChange([start, end])
                        }
                    }, {
                        text: '한달',
                        onClick: ()=> {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            this.setState({value2: [start, end]})
                            this.daterangepicker2.togglePickerVisible()
                            this.handleChange([start, end])
                        }
                    }, {
                        text: '3개월',
                        onClick: ()=> {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            this.setState({value2: [start, end]})
                            this.daterangepicker2.togglePickerVisible()
                            this.handleChange([start, end])
                        }
                    }, {
                        text: '6개월',
                        onClick: ()=> {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            this.setState({value2: [start, end]})
                            this.daterangepicker2.togglePickerVisible()
                            this.handleChange([start, end])
                        }
                    }]}
                />
            </>
        )
    }
}

export default withTranslation()(DateRange)
